import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import UserCircle from '../../assets/icons/UserCircle';
import './DropdownMenu.scss';
import { useAuth } from '../../context/AuthProvider';

function DropdownMenu() {
    const [isCollapsed, setIsCollapsed] = useState(true); 
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const { signOut } = useAuth();

    const handleSignOut = () => {
        signOut();
        navigate('/user/signin');
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsCollapsed(true);
            }
        }
        if (!isCollapsed) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCollapsed]);

    return (
        <div ref={menuRef}>
            <div
                className={`btn primary small dropdown-menu ${isCollapsed ? 'collapsed' : ''}`}
                onClick={() => setIsCollapsed(!isCollapsed)}
            >
                <div className='head'>
                    <UserCircle />
                </div>
                <div className='list'>
                    <Link className='option btn primary small' to={'/user/dashboard/'}>
                        Dashboard
                    </Link>
                    <button className='option btn primary small' onClick={handleSignOut}>
                        SignOut
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DropdownMenu